import { Box, Container, Typography } from '@mui/material';
import { PageHead } from '../../components/public/PageHead';

export function PrivacyPage() {
  return (
    <>
      <PageHead title="Privacy" description="Informativa sulla privacy di Cantir." />
      <Box sx={{ py: 6, px: 2 }}>
        <Container maxWidth="md">
          <Typography variant="h4" fontWeight={700} gutterBottom>Informativa sulla privacy</Typography>
          <Typography color="text.secondary" sx={{ mb: 4 }}>Ultimo aggiornamento: 2026. Contenuti placeholder da sostituire con testi legali definitivi.</Typography>
          <Typography variant="h6" fontWeight={600} sx={{ mt: 3 }}>1. Titolare del trattamento</Typography>
          <Typography paragraph>Cantir — dati di contatto da inserire.</Typography>
          <Typography variant="h6" fontWeight={600} sx={{ mt: 3 }}>2. Dati raccolti</Typography>
          <Typography paragraph>Descrivere quali dati personali vengono raccolti.</Typography>
          <Typography variant="h6" fontWeight={600} sx={{ mt: 3 }}>3. Finalità e base giuridica</Typography>
          <Typography paragraph>Finalita del trattamento e base giuridica.</Typography>
          <Typography variant="h6" fontWeight={600} sx={{ mt: 3 }}>4. Conservazione</Typography>
          <Typography paragraph>Criteri di conservazione e tempi di retention.</Typography>
          <Typography variant="h6" fontWeight={600} sx={{ mt: 3 }}>5. Diritti dell'interessato</Typography>
          <Typography paragraph>Accesso, rettifica, cancellazione, limitazione, portabilità, opposizione, reclamo.</Typography>
          <Typography variant="h6" fontWeight={600} sx={{ mt: 3 }}>6. Contatti</Typography>
          <Typography paragraph>Modalità per esercitare i diritti e contattare il titolare.</Typography>
        </Container>
      </Box>
    </>
  );
}
